/**
 * 空 / 错误状态块(app.css `.state`)。可选恢复动作(重试/返回),不留死按钮。
 */
interface StateBlockProps {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function StateBlock({ icon = '🔍', title, desc, actionLabel, onAction }: StateBlockProps) {
  return (
    <div className="state">
      <div className="ic">{icon}</div>
      <h2 className="h3 mb-3">{title}</h2>
      {desc ? <p className="muted sm">{desc}</p> : null}
      {actionLabel && onAction ? (
        <button type="button" className="btn btn-secondary mt-4" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
